import { jsx as _jsx } from "react/jsx-runtime";
import { useTrackEnteredFullScreen, useTrackExitedFullScreen } from "@air/analytics";
import { SegmentedControl } from "@air/component-segmented-control";
import { memo, useCallback, useMemo } from "react";
import { useAnnotationsToggle } from "~/components/AnnotationsV2/hooks/useAnnotationsToggle";
import { AssetModalViewMode, SEGMENTED_CONTROL_FULL_SCREEN_COMMENT_MODE_OPTIONS } from "~/components/AssetModalV2/constants";
import { useVideoContentControlsContext } from "~/components/AssetModalV2/Content/VideoContentControlsContextProvider";
import { useFullscreenContext } from "~/components/AssetModalV2/shared/context/FullscreenContext";
const isAssetModalViewMode = (value)=>{
    return value === AssetModalViewMode.Fullscreen || value === AssetModalViewMode.View || value === AssetModalViewMode.Comment;
};
export const ModeToggleSegmentedControl = /*#__PURE__*/ memo(()=>{
    const { showAnnotations, hideAnnotations, isAnnotationsEnabled } = useAnnotationsToggle();
    const { isFullscreen, toggleFullscreen } = useFullscreenContext();
    const { pause } = useVideoContentControlsContext();
    const { trackEnteredFullScreen } = useTrackEnteredFullScreen();
    const { trackExitedFullScreen } = useTrackExitedFullScreen();
    const currentMode = useMemo(()=>{
        if (isFullscreen) return AssetModalViewMode.Fullscreen;
        if (isAnnotationsEnabled) return AssetModalViewMode.Comment;
        return AssetModalViewMode.View;
    }, [
        isFullscreen,
        isAnnotationsEnabled
    ]);
    const handleModeToggle = useCallback((option)=>{
        const newMode = option.value;
        if (!isAssetModalViewMode(newMode)) {
            return;
        }
        switch(newMode){
            case AssetModalViewMode.Fullscreen:
                hideAnnotations();
                if (!isFullscreen) {
                    toggleFullscreen();
                    trackEnteredFullScreen({
                        location: "video"
                    });
                }
                break;
            case AssetModalViewMode.View:
                hideAnnotations();
                if (isFullscreen) {
                    toggleFullscreen();
                    trackExitedFullScreen({
                        location: "video"
                    });
                }
                break;
            case AssetModalViewMode.Comment:
                showAnnotations();
                if (isFullscreen) {
                    toggleFullscreen();
                    trackExitedFullScreen({
                        location: "video"
                    });
                }
                pause();
                break;
        }
    }, [
        hideAnnotations,
        showAnnotations,
        isFullscreen,
        toggleFullscreen,
        pause,
        trackEnteredFullScreen,
        trackExitedFullScreen
    ]);
    const selectedOption = SEGMENTED_CONTROL_FULL_SCREEN_COMMENT_MODE_OPTIONS.find((option)=>option.value === currentMode);
    if (!selectedOption) {
        return null;
    }
    return /*#__PURE__*/ _jsx(SegmentedControl, {
        options: SEGMENTED_CONTROL_FULL_SCREEN_COMMENT_MODE_OPTIONS,
        selectedOption: selectedOption,
        onSelect: handleModeToggle,
        activeColor: "grey",
        appearance: "square"
    });
});
ModeToggleSegmentedControl.displayName = "ModeToggleSegmentedControl";
